import { useState, useEffect } from 'react';

const testimonials = [
  {
    id: 1,
    quote: "Working with CZ Creative was a game-changer for our ministry. They understood our vision and brought it to life beautifully.",
    name: "Pastor Michael Roberts",
    organization: "Grace Community Church",
    image: "https://public.readdy.ai/ai/img_res/479187440e7ef372eb48e6a4ace508f2.jpg",
    rating: 5
  },
  {
    id: 2,
    quote: "The signage they created for our storefront has dramatically increased foot traffic. Professional, creative, and results-driven!",
    name: "Jennifer Martinez",
    organization: "Urban Brew Cafe",
    image: "https://readdy.ai/api/search-image?query=professional%20business%20woman%20headshot%20portrait%20smiling%20confidently%2C%20clean%20background%2C%20professional%20corporate%20photography&width=100&height=100&seq=testimonial3&orientation=squarish",
    rating: 5
  },
  {
    id: 3,
    quote: "CZ Creative transformed our entire brand identity. Their attention to detail and creative expertise exceeded all expectations.",
    name: "David Thompson",
    organization: "InnovateTech Solutions",
    image: "https://readdy.ai/api/search-image?query=professional%20businessman%20headshot%20portrait%20smiling%2C%20clean%20background%2C%20professional%20corporate%20photography%20with%20natural%20lighting&width=100&height=100&seq=testimonial4&orientation=squarish",
    rating: 5
  }
];

export default function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <div className="flex items-center justify-center space-x-2 mb-6">
          <div className="w-2 h-2 bg-[#06B6D4] rounded-full"></div>
          <span className="text-[#06B6D4] text-sm font-semibold uppercase tracking-wider">
            Client Love
          </span>
        </div>

        <div className="relative mb-10">
          <i className="ri-double-quotes-l text-[#06B6D4] text-7xl opacity-15 absolute -top-4 left-1/2 -translate-x-1/2"></i>
          <p className="text-3xl lg:text-4xl font-serif text-gray-900 leading-relaxed relative z-10">
            &ldquo;{currentTestimonial.quote}&rdquo;
          </p>
        </div>

        <div className="flex flex-col items-center space-y-4">
          <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0">
            <img
              src={currentTestimonial.image}
              alt={currentTestimonial.name}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <p className="font-bold text-gray-900 text-lg">{currentTestimonial.name}</p>
            <p className="text-gray-500 text-sm">{currentTestimonial.organization}</p>
            <div className="flex items-center justify-center space-x-1 mt-1">
              {[...Array(currentTestimonial.rating)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
              ))}
            </div>
          </div>
        </div>

        {/* Navigation */}
        <div className="flex items-center justify-center space-x-4 mt-10">
          <button
            onClick={handlePrev}
            className="w-10 h-10 rounded-full border border-gray-300 hover:border-[#06B6D4] hover:text-[#06B6D4] flex items-center justify-center transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>

          <div className="flex items-center space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentIndex ? 'w-8 bg-[#06B6D4]' : 'w-2 bg-gray-300'
                }`}
              />
            ))}
          </div>

          <button
            onClick={handleNext}
            className="w-10 h-10 rounded-full border border-gray-300 hover:border-[#06B6D4] hover:text-[#06B6D4] flex items-center justify-center transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
